export default "__VITE_ASSET__CJvMBI3i__"